import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { ShieldCheck as y, ArrowUpRight as f, Send as x, Archive as g } from "lucide-react";
import { forwardRef as z } from "react";
import { A as S } from "./Avatar-ihLwDM5D.js";
import { B as o } from "./Button-icgr8OM9.js";
import { D as L, c as b, d as C, f as D, a as w } from "./Drawer-oTTotTjV.js";
import { P as l } from "./Pill-uAcQLotY.js";
import { L as A } from "./LeadStatusPill-DaWOFt-a.js";
import { S as k } from "./SourcePill-CgQffD-I.js";
const I = {
  inbox: "i",
  slack: "s",
  discord: "d"
};
function a({ label: s, children: n }) {
  return /* @__PURE__ */ i(
    "div",
    {
      style: {
        display: "grid",
        gridTemplateColumns: "120px 1fr",
        alignItems: "center",
        padding: "var(--space-2) 0",
        borderBottom: "1px solid var(--border-subtle)",
        gap: "var(--space-3)"
      },
      children: [
        /* @__PURE__ */ e("span", { style: { fontSize: "var(--text-2xs)", color: "var(--text-tertiary)" }, children: s }),
        /* @__PURE__ */ e("div", { style: { fontSize: "var(--text-sm)", color: "var(--text-primary)" }, children: n })
      ]
    }
  );
}
const B = z(
  function({ open: n, onOpenChange: c, lead: t, labels: r, onOpenConversation: d, onSendToCrm: m, onArchive: p, footerSlot: v }, h) {
    const u = () => c(!1);
    return /* @__PURE__ */ e(L, { open: n, onOpenChange: c, children: /* @__PURE__ */ i(
      b,
      {
        ref: h,
        width: "md",
        "aria-label": t.name,
        "data-ls-component": "lead-detail-panel",
        "data-status": t.status,
        "data-crm-sync": t.crmSync ? "true" : void 0,
        children: [
          /* @__PURE__ */ e(C, { className: "sr-only", children: r.validatedFrom }),
          /* @__PURE__ */ e(
            D,
            {
              onClose: u,
              title: /* @__PURE__ */ i("span", { style: { display: "flex", alignItems: "center", gap: "var(--space-3)" }, children: [
                /* @__PURE__ */ e(S, { size: "xl", initials: t.initials, alt: t.name }),
                /* @__PURE__ */ i("span", { style: { display: "flex", flexDirection: "column", minWidth: 0 }, children: [
                  /* @__PURE__ */ e("span", { style: { fontSize: "var(--text-md)", fontWeight: 700 }, children: t.name }),
                  /* @__PURE__ */ e("span", { style: { fontSize: "var(--text-xs)", color: "var(--text-secondary)" }, children: t.title }),
                  /* @__PURE__ */ e("span", { style: { fontSize: "var(--text-xs)", color: "var(--text-tertiary)" }, children: t.company })
                ] })
              ] })
            }
          ),
          /* @__PURE__ */ i(w, { children: [
            /* @__PURE__ */ i(
              "section",
              {
                style: {
                  marginBottom: "var(--space-5)"
                },
                "aria-label": r.sourceEyebrow,
                children: [
                  /* @__PURE__ */ e(
                    "div",
                    {
                      style: {
                        fontSize: "var(--text-2xs)",
                        color: "var(--text-tertiary)",
                        letterSpacing: "0.06em",
                        textTransform: "uppercase",
                        marginBottom: "var(--space-2)"
                      },
                      children: r.sourceEyebrow
                    }
                  ),
                  /* @__PURE__ */ i("div", { style: { display: "flex", alignItems: "center", gap: "var(--space-2)" }, children: [
                    /* @__PURE__ */ e(
                      "span",
                      {
                        "aria-hidden": "true",
                        style: {
                          width: 24,
                          height: 24,
                          borderRadius: "var(--radius-md)",
                          background: "var(--bg-elevated)",
                          color: "var(--text-secondary)",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "var(--text-2xs)",
                          fontWeight: 700
                        },
                        children: I[t.validatedFrom]
                      }
                    ),
                    /* @__PURE__ */ e("span", { style: { fontSize: "var(--text-sm)", color: "var(--text-primary)" }, children: r.validatedFrom })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ i("section", { style: { marginBottom: "var(--space-5)" }, children: [
              /* @__PURE__ */ e(a, { label: r.accountCaption, children: /* @__PURE__ */ e(
                l,
                {
                  tone: "neutral",
                  variant: "soft",
                  size: "sm",
                  icon: /* @__PURE__ */ e(
                    "span",
                    {
                      "aria-hidden": "true",
                      style: {
                        width: 8,
                        height: 8,
                        borderRadius: "var(--radius-full)",
                        background: t.accountColor,
                        display: "inline-block"
                      }
                    }
                  ),
                  children: t.accountLabel
                }
              ) }),
              /* @__PURE__ */ e(a, { label: r.businessCaption, children: t.business }),
              /* @__PURE__ */ e(a, { label: r.lastActivityCaption, children: /* @__PURE__ */ e("time", { dateTime: t.lastActivityAt, children: r.lastActivityValue }) }),
              /* @__PURE__ */ e(a, { label: r.validatedCaption, children: /* @__PURE__ */ i(
                "span",
                {
                  style: { display: "inline-flex", alignItems: "center", gap: "var(--space-2)" },
                  children: [
                    /* @__PURE__ */ e(k, { source: t.source, children: r.source }),
                    /* @__PURE__ */ e(A, { status: t.status, size: "xs", children: r.status })
                  ]
                }
              ) }),
              t.crmSync && r.crmSyncedLabel ? /* @__PURE__ */ e("div", { style: { marginTop: "var(--space-3)" }, children: /* @__PURE__ */ e(
                l,
                {
                  tone: "success",
                  variant: "soft",
                  size: "sm",
                  icon: /* @__PURE__ */ e(y, { size: 12, "aria-hidden": "true" }),
                  children: r.crmSyncedLabel
                }
              ) }) : null
            ] }),
            /* @__PURE__ */ i("section", { style: { marginBottom: "var(--space-5)" }, children: [
              /* @__PURE__ */ e(
                "div",
                {
                  style: {
                    fontSize: "var(--text-2xs)",
                    color: "var(--text-tertiary)",
                    letterSpacing: "0.06em",
                    textTransform: "uppercase",
                    marginBottom: "var(--space-2)"
                  },
                  children: r.lastActionHeader
                }
              ),
              /* @__PURE__ */ e(
                "blockquote",
                {
                  style: {
                    margin: 0,
                    padding: "var(--space-3) var(--space-4)",
                    borderLeft: "2px solid var(--border-strong)",
                    background: "var(--bg-elevated)",
                    borderRadius: "var(--radius-md)",
                    fontSize: "var(--text-sm)",
                    color: "var(--text-primary)",
                    lineHeight: 1.5
                  },
                  children: t.lastAction
                }
              )
            ] }),
            /* @__PURE__ */ i(
              "section",
              {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "var(--space-2)"
                },
                children: [
                  /* @__PURE__ */ e(
                    o,
                    {
                      variant: "primary",
                      size: "md",
                      fullWidth: !0,
                      iconLeft: /* @__PURE__ */ e(f, { size: 14, "aria-hidden": "true" }),
                      onClick: () => d?.(t.convId),
                      children: r.openConvLabel
                    }
                  ),
                  /* @__PURE__ */ e(
                    o,
                    {
                      variant: "ghost",
                      size: "md",
                      fullWidth: !0,
                      iconLeft: /* @__PURE__ */ e(x, { size: 14, "aria-hidden": "true" }),
                      onClick: () => m?.(t.convId),
                      children: r.sendToCrmLabel
                    }
                  ),
                  /* @__PURE__ */ e(
                    o,
                    {
                      variant: "ghost",
                      size: "md",
                      fullWidth: !0,
                      iconLeft: /* @__PURE__ */ e(g, { size: 14, "aria-hidden": "true" }),
                      onClick: () => p?.(t.convId),
                      children: r.archiveLabel
                    }
                  ),
                  v
                ]
              }
            )
          ] })
        ]
      }
    ) });
  }
);
B.displayName = "LeadDetailPanel";
export {
  B as L
};
//# sourceMappingURL=LeadDetailPanel-jJ5pVLSc.js.map
